import React from 'react'
import {
  TextField
} from '@material-ui/core';

const NonPharmacologicalRecommendationsIMG = ({nonPharmacologicalRecommendationsIMG, handleChange}) => {
  return (
    <TextField  label="Recomendaciones Generales Imagen"
      variant="outlined"
      name={'non_pharmacological_recommendations_img'}
      multiline
      fullWidth
      margin={'normal'}
      value={nonPharmacologicalRecommendationsIMG || ''}
      onChange={({target}) => handleChange(target)}
      type="text" />
  )
}

export default NonPharmacologicalRecommendationsIMG
